import { hexToLinear } from '../../core/color';
import { createMeshBuilder } from '../mesh/meshBuilder';
import { SURFACE } from '../mesh/attributes';
import { boxSolid } from '../fabric/solids';

/** Separate rigid feet tuck away in flight without stretching with the perched body. */
export function buildRoofBirdFeet() {
  const builder = createMeshBuilder();
  const style = {
    color: hexToLinear('#695337'),
    surface: SURFACE.cloth,
    edgeId: 0,
    extent: [1, 1] as const,
    strokeAngle: 0,
  };
  const frame = { origin: [0, 0, 0] as const, yaw: 0 };
  for (const z of [-0.045, 0.045]) {
    boxSolid(builder, style, frame, [-0.012, -0.12, z - 0.012], [0.012, -0.035, z + 0.012]);
    boxSolid(builder, style, frame, [-0.015, -0.14, z - 0.018], [0.05, -0.12, z + 0.018]);
  }
  return builder.build();
}
